import comparerDshbSlice, { actions } from "./reducer";
import * as thunkActions from "./actions";
export const comparerDshbActions = { ...actions, ...thunkActions };
export * as ComparerDshbTypes from './types';
export default comparerDshbSlice;
